import React from 'react';
import { Button } from 'reactstrap';

export default function(props) {
	var pcp = {outline: true, color: "light", ...props, children: undefined};
	pcp.className = "xyzzy_button " + (pcp.className || "");
	return <Button {...pcp}>{props.children}</Button>;
}



// WEBPACK FOOTER //
// ./src/c/Butt.js